import React, { useState, useMemo, useEffect } from "react";
import { DatePicker, Input, Select, Button, Card, Row, Col, Statistic, Modal, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Table from "../components/Table";
import { useFetchAuditCaseReport, useFetchPassAllImportInputAudit } from "../hooks/useFetch";
const { RangePicker } = DatePicker;
// import { useFetchCase3 } from "../hooks/useFetch";

const AuditCasePage = () => {
  const today = dayjs();
  const companyId = sessionStorage.getItem("activeCompanyId");
  const [selectedDate, setSelectedDate] = useState([today, today]);
  const [type, setType] = useState("");
  const [userIdSearch, setUserIdSearch] = useState("");
  const [caseNameSearch, setCaseNameSearch] = useState("");
  const [adminNameSearch, setAdminNameSearch] = useState("");
  const [case2Search, setCase2Search] = useState("");
  const [case3Search, setCase3Search] = useState("");
  const [case2DataFiltered, setCase2DataFiltered] = useState([]);
  // const { data: case3Data } = useFetchCase3();
  const { mutateAsync: listAuditCase, isLoading } = useFetchAuditCaseReport();
  const { mutateAsync: passAllAuditCase, isLoading: isPassingAll } = useFetchPassAllImportInputAudit();
  const [data, setData] = useState([]);

  const handleClearFilters = () => {
    setSelectedDate([today, today]);
    setType("");
    setUserIdSearch("");
    setCaseNameSearch("");
    setAdminNameSearch("");
    setCase2Search("");
    setCase3Search("");
    setCase2DataFiltered([]);
  };

  const handleSearch = () => {
    let startDate = selectedDate[0].format("YYYY-MM-DD");
    let endDate = selectedDate[1].format("YYYY-MM-DD");
    listAuditCase({
      startDate,
      endDate,
      // type: type,
      // userId: userIdSearch,
    }).then((res) => {
      setData(res.result);
    }).catch((err) => {
      console.log(err);
    });
  };

  const handleApproveAll = () => {
    let startDate = selectedDate[0].format("YYYY-MM-DD");
    let endDate = selectedDate[1].format("YYYY-MM-DD");
    const countWaiting = data?.filter(item => item.auditStatus !== "Pass" && item.auditStatus !== "Fail").length || 0;

    if (countWaiting === 0) {
      message.warning('ไม่มีรายการที่รอการตรวจสอบ (Waiting) สำหรับการค้นหานี้');
      return;
    }

    Modal.confirm({
      title: 'ยืนยันการตรวจสอบทั้งหมด',
      content: `คุณต้องการอนุมัติ (Pass) รายการที่อยู่ในสถานะ "ยังไม่ตรวจ" ทั้งหมด ${countWaiting} รายการ (ระหว่างวันที่ ${selectedDate[0].format("DD/MM/YYYY")} ถึง ${selectedDate[1].format("DD/MM/YYYY")}) ใช่หรือไม่?`,
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      onOk: () => {
        return passAllAuditCase({ startDate, endDate })
          .then((res) => {
            message.success(`ตรวจสอบทั้งหมดสำเร็จ ${countWaiting} รายการ`);
            handleSearch();
          })
          .catch((err) => {
            message.error('เกิดข้อผิดพลาดในการตรวจสอบทั้งหมด');
            console.log(err);
          });
      }
    });
  };

  // Function to get remark text from record
  const getRemarkText = (record) => {
    const text = [record.case1Display, record.case2Display, record.case3Display]
      .filter(Boolean)
      .join(" ");
    return text.length > 0 ? text : "-";
  };

  // Group data by remark (only groups with actual remark, not "-")
  const remarkGroups = useMemo(() => {
    const groups = {};
    data.forEach((item) => {
      const remark = getRemarkText(item);
      // Skip if remark is "-" or empty
      if (remark === "-" || !remark || remark.trim() === "") {
        return;
      }
      if (!groups[remark]) {
        groups[remark] = {
          remark,
          count: 0,
          amount: 0,
        };
      }
      groups[remark].count += 1;
      groups[remark].amount += parseFloat(item.auditAmount || 0);
    });
    return Object.values(groups).sort((a, b) => b.count - a.count);
  }, [data]);
  return (
    <div style={{ padding: 16, background: "#f5f5f5", minHeight: "100vh", marginLeft: 16 }}>
      {/* Title */}
      <div style={{ marginBottom: 20 }}>
        <h1
          style={{
            margin: 0,
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#212121",
            letterSpacing: "0.5px",
            lineHeight: 1.2,
          }}
        >
          ตรวจสอบเคส
        </h1>
      </div>

      {/* Summary Section */}
      {/* <div
        style={{
          display: "flex",
          gap: 20,
          marginBottom: 20,
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 30,
            background: "#fff",
            borderRadius: 10,
            padding: "16px 24px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <div>
            <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
              เคสทั้งหมด :
            </div>
            <div style={{ fontSize: 28, fontWeight: "bold", color: "#212121" }}>
              {data?.length || 0}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
              ยอดรวม :
            </div>
            <div style={{ fontSize: 28, fontWeight: "bold", color: "#212121" }}>
              {data?.reduce((sum, item) => sum + (parseInt(item.amount) || 0), 0) || 0}
            </div>
          </div>
        </div>

      </div> */}


      {/* Filter Section */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: 16,
            alignItems: "end",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              วันที่
            </label>
            <RangePicker
              value={selectedDate}
              onChange={setSelectedDate}
              format="DD/MM/YYYY"
              style={{ width: "50%" }}
              allowClear={false}
            />
            <Button type="primary" onClick={handleSearch}>
              ค้นหา
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 8, background: "#52c41a", borderColor: "#52c41a" }}
              onClick={handleApproveAll}
              loading={isPassingAll}
            >
              ตรวจสอบทั้งหมด
            </Button>
          </div>

          {/* <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ประเภท
            </label>
            <Select
              value={type}
              onChange={setType}
              placeholder="เลือกประเภท"
              allowClear
              style={{ width: "100%" }}
            >
              <Option value="เติม">เติม</Option>
              <Option value="ไม่เติม">ไม่เติม</Option>
              <Option value="เติม / ไม่เติม">เติม / ไม่เติม</Option>
            </Select>
          </div>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ค้นหา "User ID"
            </label>
            <Input
              value={userIdSearch}
              onChange={(e) => setUserIdSearch(e.target.value)}
              allowClear
            />
          </div>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ค้นหา "Case Name"
            </label>
            <Input
              value={caseNameSearch}
              onChange={(e) => setCaseNameSearch(e.target.value)}
              allowClear
            />
          </div>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ค้นหา "Admin Name"
            </label>
            <Input
              value={adminNameSearch}
              onChange={(e) => setAdminNameSearch(e.target.value)}
              allowClear
            />
          </div>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ค้นหา "Case 2"
            </label>
            <Select
              onChange={(value) => { setCase2Search(value); setCase3Search("") }}
              allowClear
              style={{ width: "100%" }}
              showSearch
              value={case2Search}
            >
            {case2Data?.map((item) => ( 
                <Option key={item.id} value={item.casename}>{item.casename}</Option>
              ))} 
            </Select>
          </div>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ค้นหา "Case 3"
            </label>
            <Select
              onChange={(value) => setCase3Search(value)}
              placeholder="ค้นหา Case 3"
              allowClear
              style={{ width: "100%" }}
              showSearch
              value={case3Search}
            >
              {case2DataFiltered?.map((item) => ( 
                <Option key={item.id} value={item.casename}>{item.casename}</Option>
              ))} 
            </Select>
          </div>

          <div>
            <Button
              onClick={handleClearFilters}
              style={{
                width: "100%",
                height: "32px",
              }}
            >
              ล้างตัวกรอง
            </Button>
          </div> */}
          <div style={{ display: "flex", gap: 16 }}>
            <div style={{ minWidth: 120, maxWidth: 140 }}>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 2 }}>
                จำนวนเคสทั้งหมด
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold", color: "#212121" }}>
                {data?.length || 0}
              </div>
            </div>
            <div style={{ minWidth: 120, maxWidth: 140 }}>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 2 }}>
                ตรวจไปแล้ว
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold", color: "#218f39" }}>
                {data?.filter(item => item.auditStatus === "Pass" || item.auditStatus === "Fail").length || 0}
              </div>
            </div>
            <div style={{ minWidth: 120, maxWidth: 140 }}>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 2 }}>
                ยังไม่ตรวจ
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold", color: "#d48806" }}>
                {data?.filter(item => item.auditStatus !== "Pass" && item.auditStatus !== "Fail").length || 0}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 16 }}>
            <div style={{ minWidth: 120, maxWidth: 140 }}>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 2 }}>
                Match
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold", color: "#218f39" }}>
                {data?.filter(item => item.matchStatus == 'Match').length || 0}
              </div>
            </div>
            <div style={{ minWidth: 120, maxWidth: 140 }}>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 2 }}>
                Not Match
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold", color: "#ff0000" }}>
                {data?.filter(item => item.matchStatus == 'Not Match').length || 0}
              </div>
            </div>
            <div style={{ minWidth: 120, maxWidth: 140 }}>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 2 }}>
                Duplicate
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold", color: "#ff0000" }}>
                {data?.filter(item => item.dupStatus === 'Duplicate').length || 0}
              </div>
            </div>
          </div>

        </div>
      </div>


      {/* Table Section */}
      <Table
        data={data}
        loading={isLoading}
        refetch={handleSearch}
      />

      {/* Dashboard Section - Grouped by Remark */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginTop: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Row gutter={[16, 16]}>
          {remarkGroups.map((group, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                style={{
                  borderRadius: 8,
                  border: "1px solid #d9d9d9",
                }}
              >
                <Statistic
                  title={
                    <div
                      style={{
                        fontSize: 16,
                        color: "#666",
                        marginBottom: 8,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={group.remark}
                    >
                      {group.remark || "-"}
                    </div>
                  }
                  value={group.count}
                  suffix="รายการ"
                  valueStyle={{ color: "#1890ff", fontSize: 20 }}
                />
                <div
                  style={{
                    marginTop: 8,
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#52c41a",
                  }}
                >
                  ยอดรวม: {group.amount.toLocaleString("th-TH")}
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {remarkGroups.length === 0 && (
          <div
            style={{
              textAlign: "center",
              padding: 40,
              color: "#999",
            }}
          >
            ไม่มีข้อมูล
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditCasePage;

